import delivery1 from "./png/delivery-green.png"
import { MarafyeMark } from "../../components/Brand/MarafyeLogo"
import checkout2 from "./png/checkout-green.png"
import low_prices from "./png/save-green.png"

let HomeHowItWorks = () => {
  return (
    <section className="HomeHowItWorks" id="services">
      <div className="container">
        <div className="text-center">
          {/* <h1 className="home-title mb-5">HOW IT WORKS</h1> */}
        </div>
        <div className="row text-center" style={{ zoom: 0.9 }}>
          <div className="col-md-3 d-flex flex-column align-items-center">
            <img src={checkout2} alt="small icon depicting a shopping cart" />
            <h4 className="my-3">Place an Order</h4>
            <p className="text-muted">
              You sign up on our site to participate in a bulk order for no
              charge.
            </p>
          </div>
          <div className="col-md-3 d-flex flex-column align-items-center">
            {/* Our logo mark: several orders flowing into one */}
            <div style={{ transform: "scale(1.3)" }}>
              <MarafyeMark size={64} />
            </div>
            <h4 className="my-3">Combine orders</h4>
            <p className="text-muted">
              Our system matches you up with other orders of the same item and
              combine them.
            </p>
          </div>
          <div className="col-md-3 d-flex flex-column align-items-center">
            <img
              src={low_prices}
              alt="small icon depicting prices lowering"
              style={{
                transform: "scale(1.3)",
              }}
            />
            <h4 className="my-3">Save</h4>
            <p className="text-muted">
              You save money by buying in bulk and getting the best wholesale
              price.
            </p>
          </div>
          <div className="col-md-3 d-flex flex-column align-items-center">
            <img
              src={delivery1}
              alt="small icon depicting a shipping van"
              style={{
                transform: "scale(1.3)",
              }}
            />
            <h4 className="my-3">Shipped!</h4>
            <p className="text-muted">
              When the order is fulfilled, you are charged, and your product is
              shipped to you!
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default HomeHowItWorks
